import CustomerCustomerCheckoutPaymentMethod from 'domains/customer-checkout/molecules/payment-method'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

const CREDIT_CARD_LABEL = 'Credit Card'

/**
 * Displays multiple rows of Payment Methods in the same category
 * e.g. Virtual Account category shows all payment methods that are virtual account but from different banks
 */
const CustomerCheckoutPaymentCategory = ({
  label,
  paymentMethods,
  selectedPaymentMethodId,
  handleSelectPayment
}) => {
  // extend label with payment link to explicitly tell user the payment would generating payment link
  // - credit card
  // - credit card installment
  let labelPayment = label
  if (label.includes(CREDIT_CARD_LABEL)) { labelPayment = `${label} - Payment Link` }

  return (
    <div className='mb-4'>
      <div className='d-flex'>
        <label className='text-capitalize'>
          <strong>
            { labelPayment }
          </strong>
        </label>
      </div>
      <Card className='shadow p-3'>
        {
          paymentMethods.map((method, index) => {
            const isLast     = index + 1 === paymentMethods.length
            const isSelected = method.id === selectedPaymentMethodId

            if (method.name === 'GoPay') return
            return (
            // TODO: Use ListGroup to remove conditaionl <hr/>
              <div key={ `checkout-payment-method-${method.id}` }>
                <CustomerCustomerCheckoutPaymentMethod
                  paymentMethod={ method }
                  isSelected={ isSelected }
                  handleSelect={ handleSelectPayment }
                />
                { isLast ? null : <hr /> }
              </div>
            )
          })
        }
      </Card>
    </div>
  )
}


CustomerCheckoutPaymentCategory.defaultProps = {
  label          : 'Default Category Label',
  paymentMethods : [ {
    id             : -1,
    name           : 'Default Payment Method Name',
    description    : 'Default Description',
    url            : '',
    category       : 'default_category',
    category_label : 'Default Category',
    logo_url       : '/payment-options/gopay.png',
    rate           : {
      absolute_value   : null,
      calculation_type : 'percentage',
      percentage_value : '-0.02'
    }
  } ],
  selectedPaymentMethodId : -1,
  handleClickBack         : () => { alert('Clicked Back!') },
  handleSelectPayment     : () => { alert('Selected Payment Method!') }
}

CustomerCheckoutPaymentCategory.propTypes = {
  label          : PropTypes.string.isRequired,
  paymentMethods : PropTypes.arrayOf(
    PropTypes.shape({
      id             : PropTypes.number.isRequired,
      name           : PropTypes.string.isRequired,
      description    : PropTypes.string.isRequired,
      url            : PropTypes.string.isRequiredOrNull,
      category       : PropTypes.string.isRequired,
      category_label : PropTypes.string.isRequired,
      logo_url       : PropTypes.string.isRequired,
      rate           : PropTypes.shape({
        absolute_value   : PropTypes.string.isRequiredOrNull,
        calculation_type : PropTypes.string.isRequired,
        percentage_value : PropTypes.string.isRequiredOrNull
      }).isRequired
    })
  ),
  selectedPaymentMethodId     : PropTypes.number.isRequired,
  selectedShipmentOptionValue : PropTypes.string.isRequired,
  handleClickBack             : PropTypes.func.isRequired,
  handleSelectPayment         : PropTypes.func.isRequired
}

export default CustomerCheckoutPaymentCategory